import React, { useState } from 'react';
import { Outlet, useNavigate, useLocation } from 'react-router-dom';
import { Box, Drawer, AppBar, Toolbar, Typography, List, ListItem, ListItemIcon, ListItemText, IconButton, Avatar, Menu, MenuItem } from '@mui/material';
import { Menu as MenuIcon, Dashboard, AccountBalance, Build, Description, HowToVote, Logout, Person } from '@mui/icons-material';
import { useAuth } from '../context/AuthContext';

const drawerWidth = 240;
const menuItems = [
  { text: 'Dashboard', icon: <Dashboard />, path: '/' },
  { text: 'Finances', icon: <AccountBalance />, path: '/finances' },
  { text: 'Maintenance', icon: <Build />, path: '/maintenance' },
  { text: 'Documents', icon: <Description />, path: '/documents' },
  { text: 'Voting', icon: <HowToVote />, path: '/voting' }
];

const Layout: React.FC = () => {
  const [mobileOpen, setMobileOpen] = useState(false);
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  return (
    <Box sx={{ display: 'flex' }}>
      <AppBar position="fixed" sx={{ zIndex: t => t.zIndex.drawer + 1 }}>
        <Toolbar>
          <IconButton color="inherit" edge="start" onClick={() => setMobileOpen(!mobileOpen)} sx={{ mr: 2, display: { sm: 'none' } }}><MenuIcon /></IconButton>
          <Typography variant="h6" sx={{ flexGrow: 1 }}>StrataFair</Typography>
          <IconButton color="inherit" onClick={e => setAnchorEl(e.currentTarget)}><Avatar sx={{ width: 32, height: 32 }}><Person /></Avatar></IconButton>
          <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={() => setAnchorEl(null)}>
            <MenuItem disabled><Typography variant="body2">{user?.email}</Typography></MenuItem>
            <MenuItem onClick={() => { logout(); navigate('/login'); }}><Logout fontSize="small" sx={{ mr: 1 }} />Logout</MenuItem>
          </Menu>
        </Toolbar>
      </AppBar>
      <Drawer variant="permanent" sx={{ display: { xs: 'none', sm: 'block' }, '& .MuiDrawer-paper': { width: drawerWidth } }}>
        <Toolbar /><List>{menuItems.map(m => <ListItem key={m.text} onClick={() => navigate(m.path)} sx={{ cursor: 'pointer', bgcolor: location.pathname === m.path ? 'action.selected' : 'transparent' }}><ListItemIcon>{m.icon}</ListItemIcon><ListItemText primary={m.text} /></ListItem>)}</List>
      </Drawer>
      <Box component="main" sx={{ flexGrow: 1, p: 3, ml: { sm: `${drawerWidth}px` }, mt: 8 }}><Outlet /></Box>
    </Box>
  );
};
export default Layout;
